"use client";

import { useMomentBeacon } from "@/features/moments/use-moment-beacon";

/** Renders nothing; exists so layouts can mount the beacon hook. */
export function MomentBeacon() {
  useMomentBeacon();
  return null;
}
